import tw, { styled } from 'twin.macro';

import { Flex } from '../Layout/index';

const LabelContainer = styled(Flex)`
  ${tw`text-xs uppercase px-3 py-2 tracking-wide font-semibold`}
`;

export default LabelContainer;
